import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useProductLink } from '../../../utils/use-product-link.js';
import { getActiveVariant } from '../utils/get-active-variant.js';
import { getProductBlockVariantInfo } from '../utils/get-product-block-variant-info.js';
import { getVariantImages } from '../utils/get-variant-images.js';

const getProductColor = (variant)=>{
    var ref;
    const frameColor = ((ref = variant.frame) === null || ref === void 0 ? void 0 : ref.color.localized) || '';
    const lensColor = variant.lensColor;
    const productColor = [
        ...frameColor,
        lensColor
    ].filter(Boolean).join('-');
    return !!productColor ? productColor : null;
};
var consolidateDisplayVariants = (variants)=>{
    const facetTerms = [];
    return variants.reduce((acc, variant)=>{
        const { primaryFacetTerm  } = variant, variantImageConfig = swcHelpers.objectWithoutProperties(variant, [
            "primaryFacetTerm"
        ]);
        if (primaryFacetTerm === null) {
            return [
                ...acc,
                variantImageConfig
            ];
        }
        if (!primaryFacetTerm || facetTerms.includes(primaryFacetTerm)) {
            return acc;
        }
        facetTerms.push(primaryFacetTerm);
        return [
            ...acc,
            variantImageConfig
        ];
    }, []);
};
const getOtherVariants = (variants)=>{
    if (variants.length < 2) {
        return [];
    }
    const otherVariantsWithFacet = variants.map((variant)=>{
        var ref, ref1;
        return {
            sku: variant.sku,
            images: ((ref = variant.images) === null || ref === void 0 ? void 0 : ref[0]) ? [
                (ref1 = variant.images) === null || ref1 === void 0 ? void 0 : ref1[0]
            ] : [],
            primaryFacetTerm: getProductColor(variant)
        };
    });
    const consolidatedVariants = consolidateDisplayVariants(otherVariantsWithFacet);
    if (consolidatedVariants.length === 1) {
        return [];
    }
    return consolidatedVariants;
};
function useListingProductData(product, activeSku, additionalUrlParams) {
    var ref, ref2;
    const variants = React.useMemo(()=>[
            product.masterVariant,
            ...product.variants
        ]
    , [
        product.masterVariant,
        product.variants
    ]);
    const activeVariant = React.useMemo(()=>getActiveVariant(variants, activeSku)
    , [
        variants,
        activeSku
    ]);
    const variantInfo = getProductBlockVariantInfo(product, activeVariant, product.productType);
    const variantUrl = useProductLink(product.slug, activeSku, product.productType, additionalUrlParams);
    const promotionLabel = (ref2 = (ref = activeVariant.pricing) === null || ref === void 0 ? void 0 : ref.price.discount) === null || ref2 === void 0 ? void 0 : ref2.description;
    const variantImages = React.useMemo(()=>{
        const [front, angle] = getVariantImages(activeVariant, undefined, true);
        return {
            front,
            angle
        };
    }, [
        activeVariant
    ]);
    const otherVariants = React.useMemo(()=>getOtherVariants(variants)
    , [
        variants
    ]);
    const isInsuranceReimbursable = activeVariant.isInsuranceReimbursable;
    return {
        variantInfo,
        variantUrl,
        promotionLabel,
        variantImages,
        otherVariants,
        isInsuranceReimbursable
    };
}

export { consolidateDisplayVariants, getOtherVariants, useListingProductData };
//# sourceMappingURL=use-listing-product-data.js.map
